// Contracts — pothos upload precheck (H-QA round 3, 2026-06-11).
// Worker side: precheckCode in apps/api/src/pothos/upload.ts (decoder-only
// pre-flight; the SAME scanCodes the synchronous uploadAsset pre-flight runs —
// the server re-decodes on submit and stays authoritative).
// Web side: startCodePrecheck in apps/web/src/pothos/lib/uploadFlow.ts —
// fires when the composer file is picked so a code-less photo flips the
// submit button to t('reason.no_code') before the user even taps it.
import { z } from 'zod';

// Field names mirror uploadAsset's body (fileBase64 / mimeType).
// 9_000_000 ≈ base64 of the ~6.5MB image ceiling the upload path accepts.
export const PothosPrecheckCodeReqSchema = z.object({
  fileBase64: z.string().trim().min(1).max(9_000_000),
  mimeType: z.string().trim().min(1).max(100),
});
export type PothosPrecheckCodeReq = z.infer<typeof PothosPrecheckCodeReqSchema>;

export const PothosPrecheckCodeResSchema = z.object({
  found: z.boolean(),
});
export type PothosPrecheckCodeRes = z.infer<typeof PothosPrecheckCodeResSchema>;
